import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconPooja } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openChat, setFocusedTab } from '../../../chat/actions.web';
import { ChatTabs } from '../../../chat/constants';
class PoojaStepsButton extends AbstractButton {
    accessibilityLabel = 'Pooja Steps';
    icon = IconPooja;
    label = 'Pooja Steps';
    tooltip = 'Pooja Steps';
    _handleClick() {
        this.props.dispatch(openChat());
        this.props.dispatch(setFocusedTab(ChatTabs.POOJA));
    }
}
export default translate(connect((_state) => ({}))(PoojaStepsButton));
